import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { Shield, Lock, CreditCard, Zap, Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="bg-dark-900 py-20 px-4 relative overflow-hidden" data-id="element-151">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-primary/10 rounded-full blur-[150px] pointer-events-none" data-id="element-152"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-153">
        <div className="text-center mb-12" data-id="element-154">
          <h2 className="text-2xl md:text-3xl font-bold text-urgency mb-6 flex items-center justify-center" data-id="element-155">
            <span className="mr-2" data-id="element-156">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <Countdown data-id="element-157" />
          <p className="text-cream/80 mt-4 flex items-center justify-center" data-id="element-158">
            <span className="text-urgency mr-2" data-id="element-159">⚠️</span> Después sube $8.000
            ARS. No vuelve.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-16" data-id="element-160">
          <div className="flex justify-between text-sm mb-2 text-cream/90 font-medium" data-id="element-161">
            <span className="flex items-center" data-id="element-162">
              <span className="w-2 h-2 rounded-full bg-urgency mr-2 animate-pulse" data-id="element-163"></span>
              Cupos al precio de lanzamiento — Quedan pocos
            </span>
            <span data-id="element-164">68%</span>
          </div>
          <div className="w-full bg-dark-800 rounded-full h-3 overflow-hidden border border-primary/20" data-id="element-165">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-primary to-urgency h-3 rounded-full" data-id="element-166"></motion.div>
          </div>
          <p className="text-xs text-center text-cream/50 mt-2" data-id="element-167">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h3 className="text-3xl md:text-4xl font-bold text-center text-cream mb-12 flex items-center justify-center" data-id="element-168">
          <CreditCard className="w-8 h-8 mr-3 text-primary" data-id="element-169" /> ELEGÍ TU MEGAPACK
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16" data-id="element-170">
          {/* Standard Pack */}
          <motion.div whileHover={{
          y: -10
        }} className="bg-dark-800 rounded-3xl p-8 border border-primary/30 flex flex-col h-full shadow-xl" data-id="element-171">
            <div className="text-center mb-6" data-id="element-172">
              <h4 className="text-2xl font-bold text-cream mb-2 flex items-center justify-center" data-id="element-173">
                <span className="mr-2" data-id="element-174">📘</span> MEGAPACK
              </h4>
              <p className="text-primary font-semibold mb-4" data-id="element-175">
                NIÑOS SIN PANTALLAS
              </p>
              <p className="text-cream/80 text-sm mb-6" data-id="element-176">6 Tomos + 6 Bonos</p>
              <div className="bg-dark-900 rounded-lg py-2 px-4 inline-block mb-6 border border-primary/20" data-id="element-177">
                <p className="text-xs text-cream/70" data-id="element-178">Ideal para:</p>
                <p className="text-sm font-medium text-cream" data-id="element-179">
                  Familias con niños de 2 a 12 años
                </p>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-180">
              <p className="text-urgency line-through text-xl mb-2" data-id="element-181">$51.000</p>
              <div className="flex items-start justify-center" data-id="element-182">
                <span className="text-2xl text-cta mt-2 mr-1" data-id="element-183">$</span>
                <span className="text-6xl font-bold text-cta" data-id="element-184">15.990</span>
                <span className="text-xl text-cta mt-auto mb-2 ml-1" data-id="element-185">ARS</span>
              </div>
            </div>

            <a href="https://www.digitalbibliotec.online/cart/52123281490202:1" target="_blank" rel="noopener noreferrer" className="block w-full hover:bg-primary text-cream font-bold py-4 px-6 rounded-full border border-primary transition-all mb-4 bg-[#4ADAB1] text-center" data-id="element-186">
              👉 QUIERO EL MEGAPACK AHORA
            </a>
          </motion.div>

          {/* Premium Pack */}
          <motion.div whileHover={{
          y: -10
        }} className="bg-gradient-to-b from-primary-dark to-dark-800 rounded-3xl p-8 border-2 border-gold flex flex-col h-full shadow-[0_0_30px_rgba(245,158,11,0.15)] relative" data-id="element-187">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-dark-900 font-bold py-1 px-4 rounded-full text-sm flex items-center shadow-lg" data-id="element-188">
              <Star className="w-4 h-4 mr-1 fill-dark-900" data-id="element-189" /> MÁS ELEGIDO
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-190">
              <h4 className="text-2xl font-bold text-cream mb-2 flex items-center justify-center" data-id="element-191">
                <span className="mr-2" data-id="element-192">🏆</span> MEGAPACK +
              </h4>
              <p className="text-gold font-bold mb-4" data-id="element-193">
                ACOMPAÑAMIENTO FAMILIAR
              </p>
              <p className="text-cream/90 text-sm mb-6 font-medium" data-id="element-194">
                6 Tomos + 6 Bonos + Kit Casos Complejos
              </p>
              <div className="bg-dark-900/50 rounded-lg py-2 px-4 inline-block mb-6 border border-gold/30" data-id="element-195">
                <p className="text-xs text-cream/70" data-id="element-196">Ideal para:</p>
                <p className="text-sm font-medium text-cream" data-id="element-197">
                  Niños con hipersensibilidad, TEA, TDAH o dependencia severa a
                  pantallas
                </p>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-198">
              <p className="text-urgency line-through text-xl mb-2" data-id="element-199">$69.000</p>
              <div className="flex items-start justify-center" data-id="element-200">
                <span className="text-2xl text-cta mt-2 mr-1" data-id="element-201">$</span>
                <span className="text-6xl font-bold text-cta" data-id="element-202">25.990</span>
                <span className="text-xl text-cta mt-auto mb-2 ml-1" data-id="element-203">ARS</span>
              </div>
            </div>

            <a href="https://www.digitalbibliotec.online/cart/52123290534170:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-cta hover:bg-cta-hover text-white font-bold py-4 px-6 rounded-full shadow-[0_0_20px_rgba(16,185,129,0.4)] transition-all mb-4 text-center" data-id="element-204">
              👉 QUIERO EL MEGAPACK + ACOMPAÑAMIENTO
            </a>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-cream/70 bg-dark-800/50 py-4 px-6 rounded-2xl border border-primary/20 max-w-3xl mx-auto" data-id="element-205">
          <div className="flex items-center" data-id="element-206">
            <Lock className="w-5 h-5 mr-2 text-primary" data-id="element-207" /> Pago 100% seguro
          </div>
          <div className="flex items-center" data-id="element-208">
            <Zap className="w-5 h-5 mr-2 text-gold" data-id="element-209" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center" data-id="element-210">
            <Shield className="w-5 h-5 mr-2 text-primary" data-id="element-211" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-212">
            <CreditCard className="w-5 h-5 mr-2 text-primary" data-id="element-213" /> Mercado Pago |
            Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </section>;
}